import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./login.css";
import { APIURL, appLoginUrl, TZ } from "../../Global";
import axios from "axios";
import { useAuth } from "../Contexts/AuthContext";
import LoadingOverlay from "react-loading-overlay";
import { useTranslation } from 'react-i18next';
function LoginPage() {
  const { t, i18n } = useTranslation();
  const { login, auth } = useAuth();
  const [loginUsername, setLoginUsername] = useState("");
  const [loginPassword, setLoginPassword] = useState("");
  const [passwordType, setPasswordType] = useState("password");
  const [error, setError] = useState("");
  const [errorKey, setErrorKey] = useState(""); // Store the translation key instead of translated text
  const [loading, setLoading] = useState(false);
  const inputRefs = useRef([]);
  const loginButtonRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  // Re-translate error message when language changes
  useEffect(() => {
    if (errorKey) {
      setError(t(errorKey));
    }
  }, [i18n.language, errorKey, t]);
  const apiCall = async () => {
    try {
      const response = await axios.post(`${APIURL}/api/v1/account/login/`, {
        username: loginUsername,
          password: loginPassword,
      });
 
      if (response.data.status === "success") {
        login({
          token: response.data.token,
          userType: response.data.user_type,
          name:response.data.name,
          user_type:response.data.user_type,
          header_alegra:response.data.header_alegra
        });
       if(response.data.user_type!=="staff"&&response.data.user_type!=="sales_admin"&&response.data.user_type!=="config_admin"){
         setErrorKey("loginPage.errorMessages.invalidUser");
       }
        // Redirect to intended path or default dashboard
        // const redirectTo = location.state?.from || `/${response.data.user_type}`;
        // navigate(redirectTo, { replace: true });
      }
      else {
        setErrorKey('loginPage.errorMessages.invalidCredentials');
      }
    } catch (err) {
      setErrorKey('loginPage.errorMessages.invalidCredentials');
    }
  };
 
  // Redirect if already logged in
  if (auth.isAuthenticated) {
    navigate(`/${auth.userType}`, { replace: true });
    return null;
  }
 
  const handleKeyDown = (e, index) => {
    if (e.key === "Enter") {  
      e.preventDefault();
      if (index === 1) {
        loginButtonRef.current.click();
      } else {
        const nextIndex = index + 1;
        if (nextIndex < inputRefs.current.length && inputRefs.current[nextIndex]) {
          inputRefs.current[nextIndex].focus();
        }
      }
    }
  };
  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(false);
    setErrorKey(""); // Clear error key when starting new login attempt
    await apiCall();
    setLoading(false);
  };
 
  return (
    <div className="login-page">
    <div className="login-container">
      {/* <p className="subtitle">{t('loginPage.subtitle')}</p> */}
     
      {error && <div className="error-message">{errorKey==="loginPage.errorMessages.invalidUser"?<>{error}<a href={appLoginUrl} className="">
                acweb.cianlogic.com
              </a></>:error}</div>}
 
      <form onSubmit={handleLogin}>
        <div className="form-group">
          <label htmlFor="username">{t('loginPage.username')}</label>
          <input
            type="text"
            id="username"
            name="loginUsername"
            placeholder={t('loginPage.usernamePlaceholder')}
            value={loginUsername}
            onChange={(e) => setLoginUsername(e.target.value)}
            required
            onInvalid={(e) => e.currentTarget.setCustomValidity(t('loginPage.errorMessages.required'))}
            onInput={(e) => e.currentTarget.setCustomValidity('')}
            ref={el => inputRefs.current[0] = el}
            onKeyDown={(e) => handleKeyDown(e, 0)}
          />
        </div>
       
        <div className="form-group" >
          <label htmlFor="password">{t('loginPage.password')}</label>
          <div className="password-input" style={{display:"flex"}}>
          <input
            type={passwordType}
            id="password"
            name="loginPassword"
            placeholder={t('loginPage.passwordPlaceholder')}
            value={loginPassword}
            onChange={(e) => setLoginPassword(e.target.value)}
            required
            onInvalid={(e) => e.currentTarget.setCustomValidity(t('loginPage.errorMessages.required'))}
            onInput={(e) => e.currentTarget.setCustomValidity('')}
            ref={el => inputRefs.current[1] = el}
            onKeyDown={(e) => handleKeyDown(e, 1)}
          />
          <button
            type="button"
            className="toggle-password"
            style={{border:"none", backgroundColor:"white"}}
            onClick={() => setPasswordType(prev => prev === "password" ? "text" : "password")}
          >
            {passwordType === "password" ? "👁️" : "👁️‍🗨️"}
          </button>
          </div>
        </div>
       <br/>
        {/* <div className="form-options">
          <a href="/forgot-password" className="forgot-password">{t('loginPage.forgotPassword')}</a>
        </div> */}
       {}
       
        <button
          type="submit"
          className="login-button1"
          ref={loginButtonRef}
          disabled={loading}
        >
          {loading ? t('loginPage.loggingIn') : t('loginPage.loginButton')}
        </button>
      </form>
    </div>
  </div>
  );
}
 
export default LoginPage;